<template>
  <v-container fill-height fluid grid-list-lg class="pa-3">
    <v-layout row wrap>
      <v-flex xs12 md3 :style="{height:blockHeight, 'overflow-y':'auto'}">
        <v-card>
          <v-system-bar window dark color="accent" style="width: 100%">
            <v-icon center>mdi-format-list-bulleted-type</v-icon>
            <v-toolbar-title class="ml-1 pointer" @click="expanded.my=!expanded.my">Мои статистики <v-icon>{{expanded.my?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <v-btn icon slot="activator" @click="openStatisticForm(null)" class="mx-0"><v-icon class="mx-0">mdi-plus</v-icon></v-btn>
              <span>Добавить статистику</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn icon slot="activator" @click="openFolderForm(null)" class="mx-0"><v-icon class="mx-0">mdi-folder-plus</v-icon></v-btn>
              <span>Добавить папку</span>
            </v-tooltip>
          </v-system-bar>
          <v-card-text class="objects-list px-0 py-2" v-show="expanded.my">
            <v-treeview :items="my_statistics" class="densed pb-1 ovflowxscroll" item-key="key">
              <template slot="prepend" slot-scope="{ item, open, leaf }">
                <v-icon size="20" class="mx-0" @contextmenu="openMenu($event, item, 'my')">{{item.icon}}</v-icon>
              </template>
              <label slot="label" class="pointer" slot-scope="{item}" @click="getStatistic(item)" @contextmenu="openMenu($event, item, 'my')">{{item.name}}</label>
            </v-treeview>
          </v-card-text>
        </v-card>
  
        <v-card class="mt-3">
          <v-system-bar window dark color="accent" style="width: 100%">
            <v-icon center>mdi-share-variant</v-icon>
            <v-toolbar-title class="ml-1 pointer" @click="expanded.shared=!expanded.shared">Доступные мне <v-icon>{{expanded.shared?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon></v-toolbar-title>
          </v-system-bar>
          <v-card-text class="objects-list px-0 py-2" v-show="expanded.shared">
            <v-treeview :items="shared_statistics" class="densed pb-1 ovflowxscroll" item-key="key">
              <template slot="prepend" slot-scope="{ item, open, leaf }">
                <v-icon size="20" class="mx-0" @contextmenu="openMenu($event, item, 'shared')">{{item.icon}}</v-icon>
              </template>
              <label slot="label" class="pointer" slot-scope="{item}" @click="getStatistic(item)" @contextmenu="openMenu($event, item, 'shared')">{{item.name}}</label>
            </v-treeview>
          </v-card-text>
        </v-card>
  
        <v-card class="mt-3">
          <v-system-bar window dark color="accent" style="width: 100%">
            <v-icon center>mdi-delete</v-icon>
            <v-toolbar-title class="ml-1 pointer" @click="expanded.trash=!expanded.trash">Корзина <v-icon>{{expanded.trash?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon></v-toolbar-title>
          </v-system-bar>
          <v-card-text class="objects-list px-0 py-2" v-show="expanded.trash">
            <v-treeview :items="trash_statistics" class="densed pb-1 ovflowxscroll" item-key="key">
              <template slot="prepend" slot-scope="{ item, open, leaf }">
                <v-icon size="20" class="mx-0" @contextmenu="openMenu($event, item, 'trash')">{{item.icon}}</v-icon>
              </template>
              <label slot="label" class="pointer" slot-scope="{item}" @click="" @contextmenu="openMenu($event, item, 'trash')">{{item.name}}</label>
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-flex>
      
      <v-flex xs12 md9 :style="{height:blockHeight, 'overflow-y':'auto'}" v-if="selectedStatistic">
        <v-card>
          <v-system-bar window dark color="accent" style="width: 100%">
            <v-icon center>mdi-chart-line</v-icon>
            <v-toolbar-title class="ml-1">Статистика</v-toolbar-title>
          </v-system-bar>
          
          <v-card-text class="pa-0">
            <v-flex xs12 class="text-xs-center" v-if="loaded">
              <template v-if="mode==='table'">
                <div class="text-xs-center my-3">
                  <span class="pull-left" v-if="statistic.unit">Ед. изм. : {{statistic.unit}}</span>
                  <span class="title blue-grey--text">{{statistic.name}}</span>
                  <v-btn small class="pull-right" color="secondary" @click="">График</v-btn>
                </div>
    
                <v-data-table
                  :headers="headers"
                  :items="items"
                  hide-actions
                  no-data-text="Данные не введены"
                  class="statistic-data-table"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-center" v-html="props.item.name"></td>
                    <td class="text-xs-center" v-for="(el, index) in props.item.data" :key="index">{{el.value}}</td>
                  </template>
                </v-data-table>
              </template>
              <d-statistic v-else :statistic="statistic" :height="7/16*100+'%'" with_periods with_table @table-view="tableMode"></d-statistic>
            </v-flex>
            <v-flex xs12 class="text-xs-center py-5" v-else>
              <p>Загрузка ...</p>
              <v-progress-circular :size="70" :width="7" indeterminate color="primary"></v-progress-circular>
            </v-flex>
          </v-card-text>
        
        </v-card>
      </v-flex>
    </v-layout>
    
    <v-menu v-model="menu.show" :position-x="menu.x" :position-y="menu.y" absolute offset-y>
      <v-list id="analytics-objects-menu">
        <v-list-tile v-if="currentObject && currentObject.element_type ==='graph'" @click="infoItem">
          <v-list-tile-action><i class="mdi mdi-information"></i></v-list-tile-action>
          <v-list-tile-title>Информация</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="currentTree==='my'" @click="editItem">
          <v-list-tile-action><i class="mdi mdi-pencil"></i></v-list-tile-action>
          <v-list-tile-title>Редактировать</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="currentTree==='my' && currentObject.element_type ==='folder'" @click="openFolderForm(null, currentObject.id)">
          <v-list-tile-action><i class="mdi mdi-folder-plus"></i></v-list-tile-action>
          <v-list-tile-title>Добавить папку</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="currentTree==='my' && currentObject.element_type ==='folder'" @click="openStatisticForm(null, currentObject.id)">
          <v-list-tile-action><i class="mdi mdi-plus"></i></v-list-tile-action>
          <v-list-tile-title>Добавить статистику</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="currentTree!=='shared'" @click="deleteItem">
          <v-list-tile-action><i class="mdi mdi-delete"></i></v-list-tile-action>
          <v-list-tile-title>Удалить</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="currentTree==='trash'" @click="restoreItem">
          <v-list-tile-action><i class="mdi mdi-restore"></i></v-list-tile-action>
          <v-list-tile-title>Восстановить</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    
    <v-dialog v-model="dialog" :max-width="dialogWidth" scrollable persistent>
      <component :is="currentComponent" v-if="dialog" v-bind="formProps" @close-dialog="dialog=false" @save="saveChanges"></component>
    </v-dialog>
  </v-container>
</template>

<script>
  import {mapState} from 'vuex'
  import entities from '@/mixins/entities'
  import DStatistic from '../Common/Statistic'
  import FolderForm from './Forms/FolderForm'
  import InfoForm from './Forms/InfoForm'
  import StatisticForm from './Forms/StatisticForm'
  
  export default {
    name : "Analytics",
  
    mixins: [entities],
    
    components:{
      DStatistic,
    },
  
    created() {
      this.getTree()
      this.$store.dispatch('analytics/statistics/getProperties')
    },
    
    computed:{
      blockHeight(){
        return (this.$vuetify.breakpoint.height - 48 - 40 - 30 )+'px'
      },
      ...mapState(`analytics/statistics`, ['my_statistics', 'shared_statistics', 'trash_statistics']),
    },
    
    data(){
      return {
        menu:{
          x: 0,
          y: 0,
          show: false
        },
        currentTree: null,
        currentObject: null,
        currentComponent: null,
        dialog: false,
        formProps: {},
        dialogWidth: 600,
        selectedStatistic: null,
        statistic: {},
        mode: 'graph',
        loaded: false,
        expanded: {
          my: true,
          shared: true,
          trash: false
        },
        items: []
      }
    },
  
    methods: {
      getTree(){
        this.$store.dispatch('analytics/statistics/getGraphs')
      },
  
      changePeriod(data){
        data.element_type = 'graph'
        this.getStatistic(data, data.period_type)
      },
      
      getStatistic(item, period){
        if(item.element_type==='graph'){
          if(typeof period==='undefined') period = 0
          this.mode = 'graph'
          this.loaded = false
          this.selectedStatistic = item.id
          this.$store.dispatch('analytics/statistics/getGraphData', {id: item.id, period: period, type: 'graph', mode: 'graph', data: {}}).then( response => {
            response.unit = ''
            response.period_type = period
            this.statistic = response
            this.loaded = true
            this.convertOutputSettings(response.lines)
          }).catch( error => {
            this.loaded = true
            let message = 'Возникла ошибка при попытке загрузить график'
            if(error.response && error.response.data.message){
              message = error.response.data.message
            }
            this.$dmsErrorNoty(message)
          })
        }
      },
  
      tableMode(id, period){
        this.mode = 'table'
        this.loaded = false
        this.selectedStatistic = id
        if(typeof period==='undefined') period = 0
        this.$store.dispatch('analytics/statistics/getGraphData', {id: id, period: period, type: 'graph', mode: 'table', data: {} }).then( response => {
          this.loaded = true
          this.convertOutputSettings(response.lines)
          response.unit = ''
          response.period_type = period
          this.statistic = response
          this.headers = [{
            text: 'Объект',
            sortable: false,
            align: 'center',
            class: 'stat-table-header'
          }]
          response.dates.forEach( item => {
            this.headers.push({
              text: item,
              sortable: false,
              align: 'center',
              class: 'stat-table-header'
            })
          })
      
          this.items = []
          response.lines.forEach( item => {
            let temp = {}
            temp.name = item.name
            temp.data = []
            response.dates.forEach( obj => {
              const index = item.data.findIndex( el => el.date === obj )
              if( index > -1 ) temp.data.push( { value : item.data[ index ].value, date : obj } )
              else temp.data.push( { value : '', date : obj } )
            })
            this.items.push( temp )
          })
        })
      },
  
      openStatisticForm(data = null, parent_id = null){
        this.currentComponent = StatisticForm
        this.formProps = {
          parent_id
        }
        if(data!=null){
          this.formProps = {
            editMode: true,
            data,
            parent_id
          }
        }
        this.dialogWidth = 1000
        this.dialog = true
      },
      
      openFolderForm(data = null, parent_id = null){
        this.currentComponent = FolderForm
        this.formProps = {
          type: 'graph',
          parent_id
        }
        if(data!=null){
          this.formProps = {
            editMode: true,
            data,
            type: 'graph',
            parent_id
          }
        }
        this.dialogWidth = 600
        this.dialog = true
      },
      
      openMenu( e, item, tree ) {
        e.preventDefault()
        this.currentObject = item
        this.currentTree = tree
        this.menu.show = false
        this.menu.x = e.clientX
        this.menu.y = e.clientY
        this.$nextTick( () => {
          this.menu.show = true
        })
      },
      
      editItem(){
        if(this.currentObject.element_type === 'folder'){
          this.openFolderForm(this.currentObject, this.currentObject.parent_id)
        } else if(this.currentObject.element_type === 'graph'){
          this.openStatisticForm(this.currentObject, this.currentObject.parent_id)
        }
      },
  
      deleteItem(){
        let trash = (this.currentTree === 'trash')
        if(this.currentObject.element_type === 'folder'){
          this.$dmsAgree('Вы уверены, что хотите удалить папку и все вложенные элементы?').then( _ => {
            this.$store.dispatch('analytics/statistics/deleteFolder', {id: this.currentObject.id, type: 'graph', trash}).catch( error => {
              let message = 'Возникла ошибка при удалении папки'
              if(error.response && error.response.data.message){
                message = error.response.data.message
              }
              this.$dmsErrorNoty(message)
            })
          })
        } else if(this.currentObject.element_type === 'graph'){
          this.$dmsAgree('Вы уверены, что хотите удалить статистику?').then( _ => {
            this.$store.dispatch('analytics/statistics/deleteGraph', {id: this.currentObject.id, trash}).catch( error => {
              let message = 'Возникла ошибка при удалении статистики'
              if(error.response && error.response.data.message){
                message = error.response.data.message
              }
              this.$dmsErrorNoty(message)
            })
          })
        }
      },
  
      restoreItem(){
        if(this.currentObject.element_type === 'folder'){
          this.$store.dispatch('analytics/statistics/restoreFolder', {id: this.currentObject.id, type: 'graph'}).catch( error => {
            let message = 'Возникла ошибка при восстановлении папки'
            if(error.response && error.response.data.message){
              message = error.response.data.message
            }
            this.$dmsErrorNoty(message)
          })
        } else if(this.currentObject.element_type === 'graph'){
          this.$store.dispatch('analytics/statistics/restoreGraph', this.currentObject.id).catch( error => {
            let message = 'Возникла ошибка при восстановлении статистики'
            if(error.response && error.response.data.message){
              message = error.response.data.message
            }
            this.$dmsErrorNoty(message)
          })
        }
      },
  
      infoItem(){
        this.currentComponent = InfoForm
        this.formProps = {
          id: this.currentObject.id,
          type: 'graph'
        }
        this.dialogWidth = 600
        this.dialog = true
      },
  
      saveChanges(){
      
      }
    }
  }
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Statistics/Analytics.vue